export const addTreatmentToFavoriteEndpoint = (id: string) =>
  `/treatments/${id}/favorites`;
